<template>
  <div class="transition w-11/12 mx-auto
            duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">
      <button class="w-full my-3" @click="loadTeacherDashboard">
        <heading-mobile
        :user-name="teacher.name"
        :url-photo="teacher.urlProfilePhoto"
        :stars-avg="teacher.stars_avg"
        />
      </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HeadingMobile from '../HeadingMobile.vue';

export default {
  components: {
    HeadingMobile,
  },

  props: ['teacher'],

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
  },

  methods: {
    ...mapActions({
      loadTeacher: 'teachers/getTeacher',
    }),

    loadTeacherDashboard() {
      // this.loadTeacher(this.id);
      this.$router.replace({ path: `/teachers/${this.teacher.slug}` });
    },
  },
};
</script>
